import { RouteObject } from 'react-router-dom';

import { PATH } from '~/constants/route-path';
import PApi from '~/pages/api/PApi';

const API_ROUTES: RouteObject[] = [
  {
    path: PATH.API,
    element: <PApi />,
  },
];

export { API_ROUTES };
